
import React, { useState } from "react";
import styles from "./AnnouncementBar.module.css";

const AnnouncementBar = ({ announcement }) => {
  const [visible, setVisible] = useState(true);

  const hasTitle = typeof announcement?.title === 'string' && announcement.title.trim() !== '';
  const hasBody = typeof announcement?.body === 'string' && announcement.body.trim() !== '';

  if ((!hasTitle && !hasBody) || !visible) return null;

  return (
    <div className={styles.announcementBar}>
      <span className={styles.icon} aria-label="お知らせ">
        <img src="/icons/Megaphone2.svg" alt="お知らせ" style={{width: '1.2em', verticalAlign: 'middle'}} />
      </span>
      <div className={styles.textWrap}>
        {hasTitle && <strong className={styles.title}>{announcement.title}</strong>}
        {hasBody && <span className={styles.body}>{announcement.body}</span>}
      </div>
      <button className={styles.closeBtn} onClick={() => setVisible(false)} aria-label="閉じる">×</button>
    </div>
  );
};

export default AnnouncementBar;
